<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody allSearchBody">

          <div class="detailContent">
                <!--Tabs v-model="tabModel" @on-click="changeModeFN">
                    <TabPane :label="$t('chineseVal')" name="name1"></TabPane>
                    <TabPane :label="$t('outVal')" name="name2"></TabPane>，。；，怕
                </Tabs-->
                <div class="searchClass allSearchCenter">
                     <Input prefix="ios-search" v-model="queryModel" :placeholder="$t('allSearch')" style="width: auto" />
                    <div class="selectOption marginClass">
                        <Button type="info" @click="submitQuery">{{$t("queryVal")}}</Button>
                    </div>
                </div>
                 <Tabs :value="choseName">
                    <TabPane :label="item.name+'('+item.totalNum+')'" v-for="(item,index) in resultList" :key="index" :name="'name'+(index+1)">
                        <div class="resultContent" v-if="item.name!='资讯'">
                            <div class="resultInnerItem" v-for="(items,indexs) in item.data" :key="indexs" @click="goPatternPage(items)">
                                <div class="resultItem" :style="{backgroundImage:'url(' +  items.cover + ')'}"></div>
                                <div class="resultTitle">{{items.title}}</div>
                            </div>
                            <div class="resultTabShow"></div>
                            <div class="resultTabShow"></div>
                            <div class="resultTabShow"></div>
                            <div class="resultTabShow"></div>
                            <div class="resultTabShow"></div>
                            <div class="resultTabShow"></div>

                        </div>
                        <div class="resultContent" style="justify-content:flex-start" v-else>
                            <List>
                                <ListItem @click.native="goToPageFN(items.id)" v-for="(items,index) in item.data" :key="index">
                                <ListItemMeta :title="items.title" :description="items.description" />
                                </ListItem>
                            </List>
                        </div>
                    </TabPane>

                </Tabs>

                <!-- <div class="resultPage">
                    <Page @on-change="changePageFN" :page-size="pageSizeVal" :total="totalPageNum" show-total />
                </div> -->
          </div>
      </div>

      <footerView></footerView>
  </div>
</template>

<script>
// import swiper from '@/components/swiper.vue'

import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { allSearchRequest } from '../request/request'
export default {
  name: 'detail',
  components: {
    headerShow, footerView
    // swiper
  },
  data () {
    return {
      choseName: 'name1',
      languageVal: 'ch',
      queryModel: '',
      resultList: []

    }
  },
  computed: {

  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  methods: {
    async allSearchRequestFN (e) {
      var res = await allSearchRequest(e)
      if (res.data.code === 0) {
        this.resultList = res.data.data
      }
    },
    changePageFN () {},
    goToPageFN (e) {
      this.$router.push({
        path: '/newsDetail',
        name: 'newsDetail',
        query: {
          id: e

        }
      })
    },
    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },
    initFN () {
      this.queryModel = this.$route.query.value
      this.allSearchRequestFN({ lang: this.languageVal, query: this.queryModel })
    },
    submitQuery () {
      this.allSearchRequestFN({ lang: this.languageVal, query: this.queryModel })
    },
    goPatternPage (e) {
      if (e.contentType == 1) {
        this.$router.push({
          path: '/patternDetail',
          name: 'patternDetail',
          query: {
            id: e.id
          }
        })
      }
      if (e.contentType == 2) {
        this.$router.push({
          path: '/newsDetail',
          name: 'newsDetail',
          query: {
            id: e.id
          }
        })
      }
      if (e.contentType == 3) {
        this.$router.push({
          path: '/costum',
          name: 'costum',
          query: {
            id: e.id
          }
        })
      }

    //   if (e.contentType === 1) {}
    }
  }
}
</script>
<style lang="scss">
.resultTabShow{
    width: 15.6vw;
}
.allSearchBody{
    padding-top:1vh ;
}
.allSearchBody .allSearchCenter{
    @include centerLine
}
.resultItem{
    cursor: pointer;
}
.resultPage{
    margin: 15px 0;
    @include bottomLine
}
.marginClass{
    margin-left: 15px;
}
.resultMark{
    width:15.6vw;
    min-width:160px;
}
.resultTitle{
    display: block;
    width:15.6vw;
    height: 5vh;
    min-height: 20px;
    font-size: 12px;
    // @include centerLine;
    align-items: flex-start;
    text-align: center;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.resultItem{
    @include fullbackground;
    margin-bottom: 1vh;
    width:15.6vw;
    height: 8.84vw;
    min-width:160px;
    min-height: 90.6px;
    background-image: url('../assets/1.png');

}
.resultContent{
    width: 100%;
    min-height: 30vh;
    @include startLine;
    justify-content:space-around;
    flex-wrap: wrap;
    margin-top:3vh;
    background: white;
    padding-top: 2vh;
}
.searchClass{
    margin: 10px 0;
    width: 100%;
    @include startLine
}
.ivu-tag{
    cursor:pointer
}
.selectOptionAll{
    width: 90%;
    margin:0 auto;
    margin-top: 15px;
    .selectTitle{
        width: 8vw;
        // @include betweenLine;
        min-width: 80px;
        font-size: 16px;
        margin-right: 5vw;
        font-weight: bold;
        // align-items:flex-start;
    }
    .selectOption{
        @include startLine;
        align-items:flex-start;
        flex-wrap: nowrap;
        .optionItems{
            @include startLine;
            flex-wrap: wrap;
        }
    }
}
.detailContent{
    width: 90%;
    margin:0 auto;
}
.home{
    width:100%;
    .header{
      background: #ffffff;
      height: 7vh;
      min-height: 60px;
      padding: 0 0px;
      @include betweenLine;
      color: white;
    }

    .homeBody{
        width: 100%;
        min-height: 75vh;

    }
    .homeBottom{
        width:100%;
        .partnerList{
            font-size: 4vh;
            width: 100%;
            @include centerLine;
            flex-direction: column;
            .partneListTitle{
                margin-top: 3vh;
                margin-bottom:3vh;
                border-bottom:2px solid #2E6DAD
            }
            .partnerListContent{
                @include startLine;
                justify-content: center;
                flex-wrap: wrap;
                width:80%;
                margin: 0 auto;
            }
        }
    }
    .ivu-modal-header{
        background: #2E6DAD
    }
}

</style>
